export default __webpack_public_path__ + "static/media/labyrinthen-floorplan-I1.6186ed89.jpg";